window.shipTodayHourThreshold = 15;

window.isWeekend = function() {
  const date = new Date();
  const dayOfWeek = date.getDay();
  const hours = date.getHours();
  
  const weekend = [5, 6, 0];
  
  if (weekend.includes(dayOfWeek)) {
    if (dayOfWeek == 5 && hours < window.shipTodayHourThreshold) {
      return false;
    }
    
    return true;
  }
  
  return false;
}

window.canShipToday = function() {
  const date = new Date();
  const hours = date.getHours();

  if(hours < window.shipTodayHourThreshold) {
    return true;
  }
  
  return false;
}

window.getDeliveryTextMobile = function () {
  if(window.isWeekend()) {
    return '<span>dinsdag in huis</span>';
  } else {
    if(window.canShipToday()) {
      return '<span>morgen in huis</span>';
    } else {
      return '<span>morgen verzonden</span>';
    }
  }
}

window.getDeliveryTextDesktop = function () {
  if(window.isWeekend()) {
    return 'Nu besteld, <span>dinsdag in huis</span>';
  } else {
    if(window.canShipToday()) {
      return 'Voor ' + window.shipTodayHourThreshold + '.00 besteld, <span>morgen in huis</span>';
    } else {
      return 'Vandaag besteld, <span>morgen verzonden</span>';
    }
  }
}
